import * as Actions from '../../actions';

const initialState = { data: null };

const listTrailerReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_TRAILER_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listTrailerReducer;
